<template>
	<div ref="idFrmPan" style="display:flex; flex-direction:row; width:100%; height:100%;">
		<popwin :ctrl="ctrlWin"></popwin>
		<popwin :ctrl="ctrlClr"></popwin>
		<popwin :ctrl="ctrlThum"></popwin>

		<div style="flex:0 0 auto; width:50px; border:0px solid red;">
			<div class="MediaItem" style="background:url(../static/images/media_img.png);  background-size:100% 100%;" ref="idMediaCha" @click="onNewMediaClick( 151 );"></div>
			<div class="MediaItem" style="background:url(../static/images/media_bg.png);   background-size:100% 100%;" ref="idMediaBgc" @click="onNewMediaClick( 152 );"></div>
			<div class="MediaItem" style="background:url(../static/images/media_lace.png); background-size:100% 100%;" ref="idMediaLac" @click="onNewMediaClick( 153 );"></div>
			<div class="MediaItem" style="background:url(../static/images/media_pho.png);  background-size:100% 100%;" ref="idMediaPho" @click="onNewMediaClick( 158 );"></div>
			<div class="MediaItem" style="background:url(../static/images/media_text.png); background-size:100% 100%;" ref="idMediaTxt" @click="onNewMediaClick( 159 );"></div>
			<div style="float:left; width:50px; height:2px; margin-top:8px; background:#aaaaaa; border-top:1px solid #bbbbbb; border-bottom:1px solid #bbbbbb;"></div>
			<div class="MediaItem" style="background:url(../static/images/media_hat.png);  background-size:100% 100%;" ref="idMediaHat" @click="onNewMediaClick( 161 );"></div>
			<div class="MediaItem" style="background:url(../static/images/media_hair.png); background-size:100% 100%;" ref="idMediaHai" @click="onNewMediaClick( 162 );"></div>
			<div class="MediaItem" style="background:url(../static/images/media_mask.png); background-size:100% 100%;" ref="idMediaMsk" @click="onNewMediaClick( 163 );"></div>
			<div class="MediaItem" style="background:url(../static/images/media_exp.png);  background-size:100% 100%;" ref="idMediaExp" @click="onNewMediaClick( 164 );"></div>
			<div class="MediaItem" style="background:url(../static/images/media_gla.png);  background-size:100% 100%;" ref="idMediaGla" @click="onNewMediaClick( 165 );"></div>
			<div class="MediaItem" style="background:url(../static/images/media_bea.png);  background-size:100% 100%;" ref="idMediaBea" @click="onNewMediaClick( 166 );"></div>
			<div class="MediaItem" style="background:url(../static/images/media_lip.png);  background-size:100% 100%;" ref="idMediaLip" @click="onNewMediaClick( 167 );"></div>
			<div class="MediaItem" style="background:url(../static/images/media_bli.png);  background-size:100% 100%;" ref="idMediaBli" @click="onNewMediaClick( 168 );"></div>
			<div class="MediaItem" style="background:url(../static/images/media_more.png); background-size:100% 100%;" ref="idMediaMor" @click="onNewMediaClick( 169 );"></div>
			<div style="float:left; width:50px; height:2px; margin-top:8px; background:#aaaaaa; border-top:1px solid #bbbbbb; border-bottom:1px solid #bbbbbb;"></div>
			<div class="MediaItem" style="background:url(../static/images/media_qr.png);   background-size:100% 100%;" ref="idMediaMor" @click="onNewMediaClick( 156 );"></div>
		</div>
		<div style="flex:1 0 auto; width:50px; border:1px solid #bbbbbb; background:#aaaaaa; display:flex; flex-direction:column;">
			<div style="flex:0 0 auto; height:50px; border:2px solid #ffffff;">
				<div style="float:left; height:30px; line-height:30px; margin-left:10px; margin-right:6px; margin-top:10px; color:#ffffff;">{{templaItem.tmName}}</div>

				<div style="float:left; height:30px; line-height:30px; margin-left:10px; margin-right:6px; margin-top:10px; color:#ffffff; border-left:1px solid #ffffff; text-indent:10px;">{{getLangText("模板名称")}}</div>
				<input type="text" style="float:left; width:200px; height:30px; margin-top:6px;" maxlength="30" v-model="templaItem.templateName">

				<div style="float:left; height:30px; line-height:30px; margin-left:16px; margin-right:6px; margin-top:10px; color:#ffffff; border-left:1px solid #ffffff; text-indent:10px;">{{getLangText("照片规格")}}</div>
				<cselect style="float:left; position:relative; z-index:999; height:36px; min-width:140px; margin-top:6px;" :defv="curResov" v-model="curResov" :ctrl="ctrlResov" :csData="dataResov"></cselect>

				<div style="float:left; height:30px; line-height:30px; margin-left:16px; margin-right:6px; margin-top:10px; color:#ffffff; border-left:1px solid #ffffff; text-indent:10px;">{{getLangText("背景色")}}</div>
				<div style="float:left; width:50px; height:28px; margin-left:0px; margin-top:10px; cursor:pointer; border:1px solid #ffffff; " ref="idBGClr" @click="onBGSetClick"></div>

				<!-- 当前客户的草稿模版才允许修改 -->
				<div class="NButton DIVNoSelect" v-if="(templaItem.templatePublish==180) && (templaItem.templateCustId==login.custId)" style="height:32px; margin-top:8px; margin-left:20px;" @click="onTemplaSaveClick" ref="idBtnSave">{{getLangText("保存")}}</div>
			</div>
			<div style="flex:1 0 auto; height:50px; border:2px solid #ffffff;" ref="idEditPan1" @mouseup="area_onmouseup" @mousemove="area_onmousemove">
				<div style="float:left; position:relative;" ref="idEditPan2">
					<div ref="idScreenPan" style="position:relative; float:left; background:#ffffff; border:0px solid red;" ></div>
					<div ref="idTempSepa" style="position:absolute; background:#ff0000;"></div>
				</div>
			</div>
		</div>
		<div style="flex:0 0 auto; width:300px; height:100%; border:0px solid red; display:flex; flex-direction:column;">
			<div style="flex:0 0 auto; float:left; width:100%; margin-top:10px; border:0px solid red;">
				<img style="width:200px; height:200px; border:1px solid #bbbbbb; margin-left:50px;" ref="idPhotoImg" @click="_click_snap">
				<div style="width:30px; height:30px; border:0px solid red; float:right; margin-right:6px; background:url(/static/images/op_thum_a.png); background-size:100% 100%; cursor:pointer;" v-if="this.templaItem.templateId && this.templaItem.templatePublish==180" @click="onThumClick"></div>
			</div>

			<div style="flex:0 0 auto; margin-top:20px; margin-left:10px; border:0px solid red; display:flex; align-items:center;">
				<radio ref="idIDFlag0" style="height:30px; margin-right:20px;" v-model="templaItem.IDFlag" :size="18" :root="{obj:this}" :grpName="'GrpIDFlag'" :val="0" :capt="getLangText('非证件照')"></radio>
				<radio ref="idIDFlag1" style="height:30px; margin-right:20px;" v-model="templaItem.IDFlag" :size="18" :root="{obj:this}" :grpName="'GrpIDFlag'" :val="1" :capt="getLangText('证件照')"></radio>
			</div>

			<div style="flex:0 0 auto; margin-top:20px; margin-left:10px; border:0px solid red; display:flex; align-items:center;">
				<radio ref="idSepa0" style="height:30px; margin-right:20px;" v-model="templaItem.sepa" :size="18" :root="{obj:this}" :grpName="'GrpSepa'" :val="0" :capt="getLangText('不切分')" :myClick="onSepaClick"></radio>
				<radio ref="idSepa1" style="height:30px; margin-right:20px;" v-model="templaItem.sepa" :size="18" :root="{obj:this}" :grpName="'GrpSepa'" :val="1" :capt="getLangText('切分')" :myClick="onSepaClick"></radio>
			</div>

			<div style="flex:0 0 auto; float:left; width:100%; display:flex; flex-direction:column;" :key="FlushKey1">
				<div style="flex:0 0 auto; float:left; width:100%; margin-top:20px; "><!-- 媒体元素坐标 -->
					<div style="float:left; width:20px;  margin-top:16px; margin-left:10px; text-align:right; padding-right:6px;">X</div>
					<CInpInt style="float:left; width:70px; height:30px; margin-top:10px;" :maxln="4" :def="curArea.left" v-model="curArea.left" :change="onLeftChange" :lab="'L41'"></CInpInt>
					<div style="float:left; width:20px;  margin-top:16px; margin-left:50px; text-align:right; padding-right:6px;">Y</div>
					<CInpInt style="float:left; width:70px; height:30px; margin-top:10px;" :maxln="4" :def="curArea.top"  v-model="curArea.top"  :change="onTopChange" :lab="'L42'"></CInpInt>
				</div>
				<div style="flex:0 0 auto; float:left; width:100%; margin-top:10px;"><!-- 媒体元素长宽 -->
					<div style="float:left; width:20px; margin-top:16px; margin-left:10px; text-align:right; padding-right:6px;">W</div>
					<CInpInt style="float:left; width:70px; height:30px; margin-top:10px;" :maxln="4" :def="curArea.width"  :change="onWidthChange" v-model="curArea.width" :lab="'L31'"></CInpInt>
					<div style="float:left; width:20px;  margin-top:16px; margin-left:50px; text-align:right; padding-right:6px;">H</div>
					<CInpInt style="float:left; width:70px; height:30px; margin-top:10px;" :maxln="4" :def="curArea.height" :change="onHeightChange" v-model="curArea.height" :lab="'L32'"></CInpInt>
				</div>
				<div style="flex:0 0 auto; float:left; width:100%; margin-top:10px;"><!-- 旋转 -->
					<div style="float:left; margin-top:16px; margin-left:10px; text-align:right; padding-right:6px;">{{getLangText("旋转")}}</div>
					<CInpInt style="float:left; width:70px; height:30px; margin-top:10px;" :maxln="4" :minv="-180" :maxv="180" :def="curArea.rotate"  :change="onRotateChange" :lab="'L2'" v-model="curArea.rotate"></CInpInt>
				</div>

				<div style="flex:0 0 auto; float:left; width:100%; margin-top:10px;" v-if="(curArea.ty1!=159)&&(curArea.ty1!=158)&&(curArea.ty1!=156)&&(0<curArea.areaNo)"><!-- 选择图像 -->
					<div class="NButton DIVNoSelect" style="margin-top:20px; margin-left:80px;" @click="onSourceSetClick">{{getLangText("选择素材")}}</div>
				</div>
			</div>

			<div v-if="(curArea.ty1==159)&&(0<curArea.areaNo)" :key="FlushKey6" >
				<div style="flex:0 0 auto; float:left; width:100%; margin-top:50px;"><!-- 文字字体 -->
					<div style="float:left; width:120px; margin-top:6px; margin-left:10px;">{{getLangText("字体")}}</div>
					<!--input type="text" style="width:160px; height:30px; text-indent:10px;" v-model="curArea.text.family" @change="onFontFamilyChange"-->
					<cselect style="float:left; position:relative; height:30px; min-width:150px; z-index:999;" :onchange="onFontFamilyChange" :defv="curArea.text.family" v-model="curArea.text.family" :ctrl="ctrlFonts" :csData="dataFonts"></cselect>
				</div>
				<div style="flex:0 0 auto; float:left; width:100%; margin-top:10px;"><!-- 文字字号 -->
					<div style="float:left; margin-top:6px; margin-left:10px; width:120px;">{{getLangText("字号")}}</div>
					<CInpInt style="float:left; width:70px; height:30px; margin-top:0px;" :maxln="3" :minv="8" :maxv="200" :def="curArea.text.size" :change="onFontSizeChange" v-model="curArea.text.size" :lab="'L1'"></CInpInt>
				</div>
				<div style="flex:0 0 auto; float:left; width:100%; margin-top:14px;"><!-- 文字颜色 -->
					<div style="float:left; margin-left:10px; width:120px;">{{getLangText("颜色")}}</div>
					<div style="float:left; width:50px; height:28px; margin-left:0px; cursor:pointer; border:1px solid #bbbbbb;" :style="{'background':curArea.text.color}" ref="idTxtClr" @click="onTxtClrSetClick"></div>
				</div>
				<div style="flex:0 0 auto; float:left; width:100%; margin-top:10px;"><!-- 文本 -->
					<div style="float:left; margin-left:10px; margin-right:6px; margin-top:4px;">{{getLangText("文本")}}</div>
					<textarea style="width:270px; height:100px; margin-left:10px;" :areaNo="curArea.areaNo" @change="onTextChange" @focus="setInputLab('L6', 1);" @blur="setInputLab('L6', 0);" ref="idAreaText">{{curArea.text.cont}}</textarea>
				</div>
			</div>

			<div style="flex:1 0 auto; float:left; width:100%; border:0px solid green; margin-top:10px; display:flex; flex-direction:column; justify-content:flex-end;"><!-- 区域列表 -->
				<div style="flex: 0 0 auto; border:0px solid blue;">
					<table style="width:100%; font-size:14px;" ref="idMedialList"></table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import html2canvas from 'html2canvas'

import CInpInt    from '../cf/cinpint'
import cselect    from '../cf/cselect'
import popwin     from '../cf/popwin'
import radio      from '../cf/cradio'

export default {
	name: 'TemplaEdit',
	components:{
		CInpInt, cselect, popwin, radio
	},
	data () {
		return {
			midParam: null,
			findc: null,
			templaItem: {},
			mediaType1: '',      // 元素的类型
			templaName: '',      // 模板名称
			sourceIds: "",       // 当前模板加载时使用到的area的资源id集合
			LabInput:{ lab: '', flag: 0 },    // flag=0, 已失去焦点, flag=1: 获得切未失去焦点

			ctrlFonts: {
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},
			ctrlWin:{                               // 弹出窗口控制属性
				w2: 1000,
				h2: 650,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				vuepath: "/FrameBody/TemplaEdit/TemplaSetSource",
				rcallFunc: this.onAreaMediaSet,                 // 指定关闭弹出窗后需要执行的回调方法
			},
			ctrlClr: {
				w2: 250,
				h2: 360,
				captHeight: 40,
				captCont: LangText("选择颜色"),
				vuepath: "/FrameBody/TemplaEdit/cfcolor",
				rcallFunc: null
			},
			ctrlThum:{                               // 弹出窗口控制属性
				w2: 500,
				h2: 460,
				captHeight: 40,                     // 标题栏高度
				captCont: "",                       // 标题
				vuepath: "/FrameBody/TemplaEdit/ThumUpd",
				rcallFunc: null,        // 指定关闭弹出窗后需要执行的回调方法
			},

			rate: 100,           // 缩放比例
			curResov: 0,         // 当前分辨率
			ctrlResov: {
				itemHeight: 26,
				bgClr: "#ffffff",
				expandEmp: false,
				size: 8
			},
			dataResov: gResov,

			FlushKey1: 100000,     // 组件刷新key
			FlushKey6: 600000,     // 组件刷新key

			areaNo: 0,             // 区域编号
			curArea:{              // 当前选中对象
				areaNo: 0,
				left: 0,
				top: 0,
				width: 0,
				height: 0,
				rotate: 0,
			},

			change_rs_ele: null,         // 当前选中的resize对象, 用于参数变化时控制

			// 区域拖动控制变量
			mv_pre: null,         // 上一次选中区域对象
			mv_ele: null,         // 当前选中的区域对象, 用于拖动区域控制
			mv_ml: 0,             // 触发拖动时的 margin-left
			mv_mt: 0,             // 触发拖动时的 margin-top
			mv_cx: 0,             // 触发拖动时的 clientX
			mv_cy: 0,             // 触发拖动时的 clientY
			rs_ele: null,         // 用于resize区域控制
			rs_cx: 0,             // 触发resize时的 clientX
			rs_cy: 0,             // 触发resize时的 clientY
		}
	},
	mounted: function(){
		if( this.$route.query==null ) return;

		this.findc = this.$route.query.findc;

		this.templaItem.templateId        = this.$route.query.templateId;         // 模板ID
		this.templaItem.templateCustId    = this.$route.query.templateCustId;     // 模板所属客户
		this.templaItem.tmId              = this.$route.query.tmId;               // 模板类型
		this.templaItem.tmName            = this.$route.query.tmName;             // 模板类型名称
		this.templaItem.templateName      = this.$route.query.templateName;       // 模板名称
		this.templaItem.width             = this.$route.query.width;              // 模板宽度
		this.templaItem.height            = this.$route.query.height;             // 模板高度
		this.templaItem.IDFlag            = this.$route.query.IDFlag;             // 证件照标志
		this.templaItem.sepa              = this.$route.query.sepa;               // 照片切分标志
		this.templaItem.bg                = this.$route.query.bg;                 // 模板背景
		this.templaItem.templatePublish   = this.$route.query.templatePublish;    // 模板发布状态
		this.templaItem.templateIcon      = this.$route.query.templateIcon;       // 模板缩略图
		this.templaItem.iconFlag          = this.$route.query.templateIconFlag;   // 图标人为更新标志
		this.templaItem.areas             = JSON.parse(JSON.stringify(this.$route.query.areas));

		if( !this.$route.query.IDFlag ) this.templaItem.IDFlag = 0;
		this.$refs["idIDFlag"+this.templaItem.IDFlag].setChecked( true );
		this.$refs["idSepa"+this.templaItem.sepa].setChecked( true );

		this.$refs["idMediaBgc"].setAttribute("title", LangText("背景") );
		this.$refs["idMediaCha"].setAttribute("title", LangText("插图") );
		this.$refs["idMediaLac"].setAttribute("title", LangText("花边") );
		this.$refs["idMediaPho"].setAttribute("title", LangText("照片") );
		this.$refs["idMediaTxt"].setAttribute("title", LangText("文本") );
		this.$refs["idMediaHat"].setAttribute("title", LangText("帽子") );
		this.$refs["idMediaHai"].setAttribute("title", LangText("头发") );
		this.$refs["idMediaMsk"].setAttribute("title", LangText("面具") );
		this.$refs["idMediaExp"].setAttribute("title", LangText("表情") );
		this.$refs["idMediaGla"].setAttribute("title", LangText("眼镜") );
		this.$refs["idMediaBea"].setAttribute("title", LangText("胡须") );
		this.$refs["idMediaLip"].setAttribute("title", LangText("嘴唇") );
		this.$refs["idMediaBli"].setAttribute("title", LangText("气泡语") );
		this.$refs["idMediaMor"].setAttribute("title", LangText("更多") );

		this.curResov = getResov(this.templaItem.width, this.templaItem.height );

		// 并获取资源路径
		this.sourceIds="";
		for( let i=0; i<this.templaItem.areas.length; i++ )
		{
			if( this.templaItem.areas[i].siId != null || this.templaItem.areas[i].siId != 0 )
			{
				if( this.templaItem.areas[i].rotate == undefined ) this.templaItem.areas[i].rotate = 0;
				if( this.sourceIds == "" )
					 this.sourceIds = this.templaItem.areas[i].siId;
				else this.sourceIds = this.sourceIds + "," + this.templaItem.areas[i].siId;
			}
		}
		setTimeout( this.getSourcePath, 50 );
	},
	watch:{
		curResov( newV, oldV ){
			if( parseInt(newV)==parseInt(oldV) ) return;
			for( let i=0; i<gResov.length; i++ )
			{
				if( newV == gResov[i].itemValue )
				{
					this.templaItem.width        = gResov[i].w;
					this.templaItem.height       = gResov[i].h;

					this.onSetMediaArea( );

					this.onSepaClick( this.templaItem.sepa, null );
				}
			}
		},
	},
	computed:{

	},
	methods:{
		onResize: function(){
			this.onSetMediaArea( );
			this.childResize( this );
		},
		/* 缩略图 */
		onThumClick: function(){
			this.ctrlThum.captCont = LangText("更新缩略图");
			this.ctrlThum.info={tmId: this.templaItem.tmId, templaId: this.templaItem.templateId,
								templaName:this.templaItem.templateName,
								templaIcon: this.templaItem.templateIcon,
								width:this.templaItem.width, height:this.templaItem.height };
			this.ctrlThum.self.onShow();
		},
		/* 查询模板中使用到的资源的路径 */
		getSourcePath: function(){
			if( this.sourceIds=="" )
			{
				this.getSourcePathOK( {body:{code:200, body:{sourceList:[]}}} );
				return;
			}

			let body={ siIds: this.sourceIds };
			this.doTrade( "POST", ServAddr+"/api/source/sourcePath", this.getSourcePathOK, true, body, null );
		},
		getSourcePathOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			// 设置显示层级、资源路径
			for( let i=0; i<this.templaItem.areas.length; i++ )
			{
				let area=this.templaItem.areas[i];
				area.zIdx = 800 + i;  // 设置层级
				this.areaNo++;
				area.areaNo = this.areaNo;
				area.photo = "";

				for( let j=0; j<data.body.sourceList.length; j++ )
				{
					if( area.siId == data.body.sourceList[j].siId )
					{
						area.photo = data.body.sourceList[j].siImgPath;    // 设置资源路径
					}
				}
				this.showMediaArea( area );   // 显示 area
			}

			// 人为上传的缩略图, 不被自动生成的替换
			if( this.templaItem.iconFlag == 1 )
			{
				let wh = this.getZoomSize(200, 200, this.templaItem.width, this.templaItem.height);
				this.$refs["idPhotoImg"].style["width"]  = (wh[0])+"px";
				this.$refs["idPhotoImg"].style["height"] = (wh[1])+"px";
				this.$refs["idPhotoImg"].style["margin-left"] = ((300-wh[0])/2)+"px";
				this.$refs["idPhotoImg"].src = this.templaItem.templateIcon;
			}
		},
		/* 保存缩略图 */
		_snapPhoto: function( saveFlag ){
			if( this.templaItem.iconFlag == 1 )
			{
				this.snapEnd( null, 0, 0, saveFlag );
				return;
			}

			let that=this;
	        let shareContent = this.$refs["idScreenPan"];

			// 将所有的area的边框置为空
			if( saveFlag )
			{
				if( this.mv_pre )
				{
					this.mv_pre.style["border"] = "1px solid #00ffff";
					let blk = this.mv_pre.childNodes[1];
					if( blk ) blk.style["display"] = "none";
				}
				let arrs=document.getElementsByClassName("MediaAreaPan");
				for( let i=0; i<arrs.length; i++ )
				{
					arrs[i].style["border"] = "0px solid #bbbbbb";
				}
			}

			this.midParam = { that, shareContent, saveFlag };
			setTimeout( this._getThumpImg, 200 );
		},
		_click_snap: function(){   /* 鼠标点击触发, 强制刷新缩略图 */
			this._snapPhoto( false );
		},
		_getThumpImg: function(){
			let that = this.midParam.that;
			let shareContent = this.midParam.shareContent;
			let saveFlag = this.midParam.saveFlag;

	        html2canvas(shareContent,{
	          logging: true, //日志开关，便于查看html2canvas的内部执行流程
	          width: shareContent.offsetWidth*that.rate,     //dom 原始宽度
	          height: shareContent.offsetHeight*that.rate,   //dom 原始高度
	          scrollY: 0,
	          scrollX: 0,
	          useCORS: true
	        }).then(function(canvas){
	          let imgUrl1 =  canvas.toDataURL('image/' + "jpg");
	          let tmpImg=that.$refs["idPhotoImg"];
	          let wh=that.getZoomSize(200, 200, shareContent.offsetWidth*that.rate, shareContent.offsetHeight*that.rate);
	          tmpImg.style["width"] = (wh[0])+"px";
	          tmpImg.style["height"]= (wh[1])+"px";
	          tmpImg.src = imgUrl1;
	          that.snapEnd( imgUrl1, tmpImg.naturalWidth, tmpImg.naturalHeight, saveFlag );   //截图完成回调

/*
	          html2canvas(tmpImg,{
		          logging: false,
		          width: wh[0],
		          height: wh[1],
		          scrollY: 0,
		          scrollX: 0,
		          useCORS: true
		        }).then(function(canvas){
		          let imgUrl2 =  canvas.toDataURL('image/' + "jpg", 0.7);
		          let w=wh[0];
		          let h=wh[1];
		          console.log( imgUrl2 );
		          that.snapEnd( imgUrl2, w, h, saveFlag );   //截图完成回调
	          });*/
	       });
		},
		snapEnd: function( url, w, h, flag ){
			if( flag )
			{
				let body={};
				body.templateId      = this.templaItem.templateId;      // 模板ID, null/0, 表示新增模板
				body.templateNameEng = this.templaItem.templateName;    // 模板名称
				body.tmId            = this.templaItem.tmId;            // 模板类型

				if( url && this.templaItem.iconFlag == 0 )              // 没有人为更新过缩略图时才允许使用自动生成的更新
				{
					body.templateIcon    = url.split(",")[1];           // 模板缩略图base64
				}
				let cfg={};
				body.templateConfig  = "";                              // 模板配置数据

				let obj=this.templaItem;
				cfg.slice  = 0;                                         // 照片张数
				cfg.bg     = obj.bg;                                    // 背景颜色
				cfg.height = obj.height;                                // 照片的高度
				cfg.width  = obj.width;                                 // 照片的宽度
				cfg.IDFlag = this.templaItem.IDFlag;                    // 证件照标志
				cfg.sepa   = this.templaItem.sepa;                      // 照片切分标志

				cfg.areas = [];
				for( let i=0; i<obj.areas.length; i++ )                 // 循环取得每个area的设置
				{
					let area1=obj.areas[i];
					let area2={};
					area2.ty1     = area1.ty1;                          // 素材类型
					area2.ty2     = area1.ty2;                          // 贴纸类型
					area2.width   = area1.width;                        // 宽度
					area2.height  = area1.height;                       // 高度
					area2.left    = area1.left;                         // 左顶点left
					area2.top     = area1.top;                          // 左顶点top
					area2.zIdx    = area1.zIdx;                         // area的层级, zIdx越大, 越位于上部
					area2.rotate  = area1.rotate;                       // 旋转角度(-180 - +180)
					area2.isCut   = area1.isCut;                        // 是否抠图人像
					area2.siId    = area1.siId;                         // 使用的素材资源ID
					area2.text = {
						family:  area1.text.family,                     // 字体
						size:    area1.text.size,                       // 字号
						color:   area1.text.color,                      // 字体颜色
						cont:    area1.text.cont,                       // 文本
					};
					cfg.areas.push( area2 );
					if( area1.ty1 == 158 ) cfg.slice++;
				}
				//body.templateConfig  = cfg;                             // 模板配置数据
				body.templateConfig = JSON.stringify( cfg );
				if( 9000 < body.templateConfig.getBytesLength() )
				{
					this.appRoot.app.showDlgTip( 1200, LangText("配置项超长"), this.CLR.Err );
					return;
				}

				if( cfg.slice > 9 )
				{
					this.appRoot.app.showDlgTip( 1200, LangText("照片不能超过9张"), this.CLR.Err );
					return;
				}

				this.doTrade( "POST", ServAddr+"/api/template/templateEdit", this.onTemplateEditOK, true, body, null );
			}
		},
		onTemplateEditOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != "200" )
			{
				this.appRoot.app.showDlgTip( 1200, this.getErrorText(data.code), this.CLR.Err );
				return;
			}

			// 置为查询草稿状态、私有状态, 以确保可以看到新增的模板
			if( this.templaItem.templateId==null )
			{
				this.findc.findPublish = 180;
				this.findc.findCustRange = this.findc.findCustRange+",2";
			}
			this.$router.push( {path:"/FrameBody/TemplaList", query:this.findc } );

		},
		/* 保存模板 */
		onTemplaSaveClick: function( ){
			this._snapPhoto( true );
		},
		/* 设置模板操作区域 */
		onSetMediaArea: function( ){
			let AreaW = this.$refs["idEditPan1"].clientWidth;
			let AreaH = this.$refs["idEditPan1"].clientHeight;

			if( this.templaItem.areas && this.templaItem.areas.length > 0 )
				 this.ctrlResov.self.setDisabled( true );
			else this.ctrlResov.self.setDisabled( false );

			let r1=this.templaItem.width / this.templaItem.height;
			let r2=AreaW / AreaH;

			if( r1 > r2 )
				 this.rate = (AreaW - 40 ) / this.templaItem.width;
			else this.rate = (AreaH - 40 ) / this.templaItem.height;

			let w=this.templaItem.width * this.rate;
			let h=this.templaItem.height* this.rate;

			this.$refs["idEditPan2"].style["width"]  = w+"px";
			this.$refs["idEditPan2"].style["height"] = h+"px";
			this.$refs["idEditPan2"].style["margin-left"] = ((AreaW-w)/2)+"px";
			this.$refs["idEditPan2"].style["margin-top"]  = ((AreaH-h)/2)+"px";
			this.$refs["idScreenPan"].style["width"]  = this.templaItem.width+"px";
			this.$refs["idScreenPan"].style["height"] = this.templaItem.height+"px";
			this.$refs["idScreenPan"].style["transform"] = "scale("+this.rate+")";
			this.$refs["idScreenPan"].style["transform-origin"] = "0px 0px";

			this.$refs["idTempSepa"].style["transform"] = "scale("+this.rate+")";
			this.$refs["idTempSepa"].style["transform-origin"] = "0px 0px";

			this.$refs["idScreenPan"].style["background"] = this.templaItem.bg;
			this.$refs["idBGClr"].style["background"] = this.templaItem.bg;

			this._snapPhoto( false );
		},
		/*  */
		resetMediaZindex: function(){
			// 对素材的层级排序
			for( let j=(this.templaItem.areas.length-1); 0<j; j-- )
			{
				for( let i=0; i<j; i++ )
				{
					let item1=this.templaItem.areas[i];
					let item2=this.templaItem.areas[i+1];
					if( item1.zIdx > item2.zIdx )  // 交换
					{
						let a=0;
						a = item1.zIdx;        item1.zIdx    =   item2.zIdx;        item2.zIdx    = a;
						a = item1.ty1;         item1.ty1     =   item2.ty1;         item2.ty1     = a;
						a = item1.ty2;         item1.ty2     =   item2.ty2;         item2.ty2     = a;
						a = item1.left;        item1.left    =   item2.left;        item2.left    = a;
						a = item1.top;         item1.top     =   item2.top;         item2.top     = a;
						a = item1.width;       item1.width   =   item2.width;       item2.width   = a;
						a = item1.height;      item1.height  =   item2.height;      item2.height  = a;
						a = item1.isCut;       item1.isCut   =   item2.isCut;       item2.isCut   = a;
						a = item1.siId;        item1.siId    =   item2.siId;        item2.siId    = a;
						a = item1.rotate;      item1.rotate  =   item2.rotate;      item2.rotate  = a;
						a = item1.photo;       item1.photo   =   item2.photo;       item2.photo   = a;
						a = item1.areaNo;      item1.areaNo  =   item2.areaNo;      item2.areaNo  = a;

						a = item1.text.bg;     item1.text.bg     =   item2.text.bg;       item2.text.bg     = a;
						a = item1.text.cont;   item1.text.cont   =   item2.text.cont;     item2.text.cont   = a;
						a = item1.text.family; item1.text.family =   item2.text.family;   item2.text.family = a;
						a = item1.text.size;   item1.text.size   =   item2.text.size;     item2.text.size   = a;
						a = item1.text.color;  item1.text.color  =   item2.text.color;    item2.text.color  = a;
					}
				}
			}

			// 重置素材的层级为 800 开始递增, 方便后续操作
			for( let i=0; i<this.templaItem.areas.length; i++ )
			{
				this.templaItem.areas[i].zIdx = 800 + i;

				let arrs=document.getElementsByClassName("MediaAreaPan");
				for( let j=0; j<arrs.length; j++ )
				{
					if( arrs[j].getAttribute("areaNo")==this.templaItem.areas[i].areaNo )
					{
						arrs[j].style["z-index"] = this.templaItem.areas[i].zIdx;
					}
				}
			}
		},
		setMediaZIndex: function( areaNo, direction ){
			for( let i=0; i<this.templaItem.areas.length; i++ )
			{
				if( this.templaItem.areas[i].areaNo == areaNo )
				{
					// 交换zIdx
					if( direction == -1 )   // 上移
					{
						if( 0 < i )
						{
							let k=this.templaItem.areas[i-1].zIdx;
							this.templaItem.areas[i-1].zIdx = this.templaItem.areas[i].zIdx;
							this.templaItem.areas[i].zIdx = k;
						}
					}
					if( direction == 1 )   // 下移
					{
						if( i < (this.templaItem.areas.length-1) )
						{
							let k=this.templaItem.areas[i+1].zIdx;
							this.templaItem.areas[i+1].zIdx = this.templaItem.areas[i].zIdx;
							this.templaItem.areas[i].zIdx = k;
						}
					}
					break;
				}
			}
			this.resetMediaZindex();

			this.showAreaList( );
		},
		/* 添加新的素材到模板中 */
		onNewMediaClick: function( ty ){
			this.resetMediaZindex();

			let item={ zIdx: this.templaItem.areas.length+800, ty1: 0, ty2: 0, left:0, top:0, width:200, height:200, isCut: 0, siId:0, rotate:0, photo:'', text:{cont:'', family:'Serif', size:80, color:'#ff0000' } }
			if( ty==151 || ty==152 || ty==153 || ty==156 || ty==158 || ty==159 )
			{
				item.ty1 = ty;
				item.ty2 = 160;
			}
			else
			{
				item.ty1 = 150;
				item.ty2 = ty;
			}

			this.areaNo++;
			item.areaNo = this.areaNo;

			this.templaItem.areas.push( item );
			this.showMediaArea( item );

			this.ctrlResov.self.setDisabled( true );
		},
		/* 显示指定素材 */
		showMediaArea: function( item ){
			let pan=document.createElement("div");
			this.$refs["idScreenPan"].appendChild( pan );
			pan.setAttribute("areaNo", item.areaNo);
			pan.setAttribute("class", "MediaAreaPan" );
			pan.setAttribute("areaty", item.ty1 );
			pan.style["z-index"] = item.zIdx;
			pan.style["width"] = item.width+"px";
			pan.style["height"]= item.height+"px";
			pan.style["left"] = (item.left)+"px";
			pan.style["top"]  = (item.top)+"px";

			if( item.rotate && item.rotate!=0 )
			{
				pan.style["transform"] = "rotate("+item.rotate+"deg)";
			}

			if( item.photo=="" )
			{
				if( item.ty1==151 ) pan.style["background"] = "url(../static/images/media_img.png)";
				if( item.ty1==152 ) pan.style["background"] = "url(../static/images/media_bg.png)";
				if( item.ty1==153 ) pan.style["background"] = "url(../static/images/media_lace.png)";
				if( item.ty1==156 ) pan.style["background"] = "url(../static/images/media_qr.png)";
				if( item.ty1==158 ) pan.style["background"] = "url(../static/images/media_pho.png)";
				if( item.ty1==159 ) pan.style["background"] = "url(../static/images/media_text.png)";
				if( item.ty2==161 ) pan.style["background"] = "url(../static/images/media_hat.png)";
				if( item.ty2==162 ) pan.style["background"] = "url(../static/images/media_hair.png)";
				if( item.ty2==163 ) pan.style["background"] = "url(../static/images/media_mask.png)";
				if( item.ty2==164 ) pan.style["background"] = "url(../static/images/media_exp.png)";
				if( item.ty2==165 ) pan.style["background"] = "url(../static/images/media_gla.png)";
				if( item.ty2==166 ) pan.style["background"] = "url(../static/images/media_bea.png)";
				if( item.ty2==167 ) pan.style["background"] = "url(../static/images/media_lip.png)";
				if( item.ty2==168 ) pan.style["background"] = "url(../static/images/media_bli.png)";
				if( item.ty2==169 ) pan.style["background"] = "url(../static/images/media_more.png)";

				if( item.ty1==156 )
				{
					pan.style["background-size"] = "100% 100%";
					pan.style["background-repeat"] = "no-repeat";
				}
				else
				{
					pan.style["background-size"] = "50px 50px";
					pan.style["background-repeat"] = "no-repeat";
				}
			}
			else
			{
				console.log("========1 "+item.photo );
				pan.style["background"] = "url("+item.photo+"?dt="+this.getUIID()+")";
				pan.style["background-size"] = "100% 100%";
			}

			pan.onmousedown = this.area_onmousedown;
			this.$refs["idScreenPan"].onmousemove = this.area_onmousemove;
			this.$refs["idScreenPan"].onmouseup   = this.area_onmouseup;

			let cont=document.createElement("div");
			pan.appendChild( cont );
			cont.style["width"] = "100%";
			cont.style["height"] = "100%";
			if( item.ty1==159 )
				 cont.style["display"] = "block";
			else cont.style["display"] = "none";

			if( item.ty1==159 )
			{
				if( item.text.cont == "" )
				{
					pan.style["background"] = "url(../static/images/media_text.png)";
					pan.style["background-size"] = "50px 50px";
					pan.style["background-repeat"] = "no-repeat";
					cont.innerText = "";
				}
				else
				{
					//pan.style["background"] = "";    //执行此句会导致背景变为白色
					pan.style["background-size"] = "0px 0px";
					cont.innerText            = item.text.cont;
					cont.style["color"]       = item.text.color;
					cont.style["font-size"]   = item.text.size+"px";
					cont.style["font-family"] = item.text.family;
					cont.style["word-wrap"]   = "break-word";
				}
			}

			let rsz=document.createElement("div");
			pan.appendChild( rsz );
			rsz.setAttribute("areaNo", item.areaNo);
			rsz.setAttribute("class", "AreaRsz");
			rsz.style["cursor"] = "nw-resize";
			rsz.style["left"] = (item.width-20)+"px";
			rsz.style["top"]  = (item.height-20)+"px";
			rsz.style["display"] = "none";
			rsz.onmousedown=this.onBlkDown;

			if( item.ty1==152 || item.ty1==153 || item.ty1==158 )   // 背景/花边/相片, 可以双击全屏
			{
				let that=this;
				pan.ondblclick = function( e ){
					item.width  = that.templaItem.width;
					item.height = that.templaItem.height;
					item.left   = 0;
					item.top    = 0;
					//console.log( that.templaItem.width, that.templaItem.height);
					pan.style["width"] = (item.width)+"px";
					pan.style["height"]= (item.height)+"px";
					pan.style["left"] = (0)+"px";
					pan.style["top"]  = (0)+"px";

					rsz.style["left"] = (item.width-20)+"px";
					rsz.style["top"]  = (item.height-20)+"px";

					this.curArea = item;
					//console.log( this.curArea );
					this.FlushKey1++;
				};
			}

			this.showAreaList( );
		},
		onAreaDel: function( areaNo ){

			for(let i=0; i<this.templaItem.areas.length; i++ )
			{
				if( this.templaItem.areas[i].areaNo == areaNo )
				{
					this.templaItem.areas.splice( i, 1 );
					let eles = document.getElementsByClassName("MediaAreaPan");
					for( let i=0; i<eles.length; i++ )
					{
						if( eles[i].getAttribute("areaNo")==areaNo )
						{
							if( eles[i]==this.mv_pre )
							{
								if( this.templaItem.areas.length==0 ) this.ctrlResov.self.setDisabled( false );
								this.curArea = { areaNo: 0, left: 0, top: 0, width: 0, height: 0, rotate:0 };
								this.FlushKey1++;
							}

							this.$refs["idScreenPan"].removeChild( eles[i] );

							this.resetMediaZindex();   // 素材层排序、重置 z-index 值

							this.showAreaList( );
						}
					}
				}
			}
		},
		showAreaList: function( ){
			// 设置素材列表选中选状态
			let tab=this.$refs["idMedialList"];
			tab.innerHTML = "";
			tab.innerHTML = "<tr style='background:#e5e5e5;'>"+
								"<td style='text-align:center;'>"+LangText("层")+"</td>"+
								"<td style='text-align:center;'>"+LangText("类型")+"</td>"+
								"<td style='text-align:center;'>"+LangText("贴纸")+"</td>"+
								"<td style='text-align:center;' colspan='3'>"+LangText("操作")+"</td></tr>";
			let tr=null;
			let td=null;
			//for( let i=0; i<this.templaItem.areas.length; i++ )
			for( let i=this.templaItem.areas.length-1; 0<=i; i-- )
			{
				let that=this;

				let area=this.templaItem.areas[i];
				tr = document.createElement("tr");
				tab.appendChild( tr );

				td = document.createElement("td");
				tr.appendChild( td );
				td.style["text-align"] = "center";
				td.style["border"] = "1px solid #ffffff";
				td.innerText = area.zIdx;

				td = document.createElement("td");
				tr.appendChild( td );
				td.style["text-align"] = "center";
				td.style["border"] = "1px solid #ffffff";
				td.setAttribute("class", "OPItem");
				td.innerText = this.getImgTypeName(area.ty1);
				td.onclick=function(){
					let arrs=document.getElementsByClassName("MediaAreaPan");
					for( let i=0; i<arrs.length; i++ )
					{
						if( arrs[i].getAttribute("areaNo")==area.areaNo )
						{
							let e={ clientX: area.left, clientY:area.top, target: arrs[i] };
							that.area_onmousedown( e );
							that.area_onmouseup( e );
						}
					}
				};

				td = document.createElement("td");
				tr.appendChild( td );
				td.style["text-align"] = "center";
				td.style["border"] = "1px solid #ffffff";
				td.innerText = this.getPasterTypeName(area.ty2);

				td = document.createElement("td");
				tr.appendChild( td );
				td.style["text-align"] = "center";
				td.style["border"] = "1px solid #ffffff";
				td.innerText = this.getLangText("删除");
				td.setAttribute("class", "OPItem");
				td.onclick=function(){ that.onAreaDel( area.areaNo ) };

				td = document.createElement("td");
				tr.appendChild( td );
				td.style["text-align"] = "center";
				td.style["border"] = "1px solid #ffffff";
				td.style["width"] = "20px";
				td.style["background"] = "url(../static/images/op_arr2.png)";
				td.style["background-size"] = "20px 20px";
				td.setAttribute("class", "OPItem");
				td.onclick=function(){  that.setMediaZIndex( area.areaNo, 1); };

				td = document.createElement("td");
				tr.appendChild( td );
				td.style["text-align"] = "center";
				td.style["border"] = "1px solid #ffffff";
				td.style["width"] = "20px";
				td.style["background"] = "url(../static/images/op_arr1.png)";
				td.style["background-size"] = "20px 20px";
				td.setAttribute("class", "OPItem");
				td.onclick=function(){  that.setMediaZIndex( area.areaNo, -1); };

				if( this.mv_pre && area.areaNo == this.mv_pre.getAttribute("areaNo") )
					 tr.style["background"] = "#e5e5e5";
				else tr.style["background"] = "#f5f5f5";
			}

			this._snapPhoto( false );
		},
		setInputLab: function( lab, flag ){
			this.LabInput.lab = lab;
			this.LabInput.flag = flag;
		},
		onSepaClick: function( oldv, newv )
		{
			if( this.templaItem.sepa==1 )
			{
				if( this.templaItem.width > this.templaItem.height )    // 横向对半切
				{
					this.$refs["idTempSepa"].style["height"] = "3px";
					this.$refs["idTempSepa"].style["width"]  = (this.templaItem.width)+"px";
					this.$refs["idTempSepa"].style["left"]   = "0px";
					this.$refs["idTempSepa"].style["top"]    = ((this.templaItem.height*this.rate-3)/2)+"px";
				}
				else // 纵向
				{
					this.$refs["idTempSepa"].style["width"] = "3px";
					this.$refs["idTempSepa"].style["height"]  = (this.templaItem.height)+"px";
					this.$refs["idTempSepa"].style["left"]   = ((this.templaItem.width*this.rate-3)/2)+"px";
					this.$refs["idTempSepa"].style["top"]    = "0px";
				}
				this.$refs["idTempSepa"].style["display"] = "block";
			}
			else
			{
				this.$refs["idTempSepa"].style["display"] = "none";
			}
		},
		/* 选择颜色 */
		onBGSetClick: function(){
			this.ctrlClr.rcallFunc = this.onGBChange;
			this.ctrlClr.info={ w2:this.ctrlClr.w2, h2:this.ctrlClr.h2, clr:this.templaItem.bg };
			this.ctrlClr.self.onShow();
		},
		onGBChange: function( clr ){
			if( clr )
			{
				this.templaItem.bg = clr;
				this.$refs["idScreenPan"].style["background"] = clr;
				this.$refs["idBGClr"].style["background"]     = clr;
			}
		},
		/* 选择当前对象的素材 */
		onSourceSetClick: function( ){
			this.ctrlWin.captCont = LangText("选择素材");
			this.ctrlWin.info={ ty1: this.curArea.ty1, ty2: this.curArea.ty2 };
			this.ctrlWin.self.onShow();
		},
		onAreaMediaSet: function( param ){
			if( !param ) return;

			this.curArea.siId  = param.siId;
			this.curArea.photo = param.path;

			this.mv_pre.style["background"] = "url("+this.curArea.photo+")";
			this.mv_pre.style["background-size"] = "100% 100%";

			this._snapPhoto( false );
		},
		/* 字体相关 */
		onFontFamilyChange: function(){
			this.onTextChange( );
		},
		onFontSizeChange: function( newV, oldV ){
			this.curArea.text.size = newV;

			this.onTextChange( );
		},
		onTxtClrSetClick: function( ){
			this.ctrlClr.rcallFunc = this.onTxtClrChange;
			this.ctrlClr.info={ w2:this.ctrlClr.w2, h2:this.ctrlClr.h2, clr:this.curArea.text.color };
			this.ctrlClr.self.onShow();
		},
		onTxtClrChange: function( clr ){
			if( clr )
			{
				this.curArea.text.color = clr;
				this.onTextChange( );
			}
		},
		onTextChange: function( ){
			if( this.curArea.ty1 != 159 ) return;

			this.curArea.text.cont = this.$refs["idAreaText"].value;
			if( this.$refs["idAreaText"].value == "" )
			{
				this.mv_pre.style["background"] = "url(../static/images/media_text.png)";
				this.mv_pre.style["background-size"] = "50px 50px";
				this.mv_pre.style["background-repeat"] = "no-repeat";
				this.mv_pre.childNodes[0].innerText = "";
			}
			else
			{
				if( this.mv_pre.getAttribute("areaty")==159 )   // 只有前一个是文本组件时, 才需要将组件图标去掉
				{
					//this.mv_pre.style["background"] = "";    //执行此句会导致背景变为白色
					this.mv_pre.style["background-size"] = "0px 0px";
				}

				this.mv_pre.childNodes[0].innerText = this.$refs["idAreaText"].value;
				this.mv_pre.childNodes[0].style["color"] = this.curArea.text.color;
				this.mv_pre.childNodes[0].style["font-size"] = this.curArea.text.size+"px";
				this.mv_pre.childNodes[0].style["font-family"] = this.curArea.text.family;
				this.mv_pre.childNodes[0].style["word-wrap"] = "break-word";
			}

			this._snapPhoto( false );
		},
		/* 手动修改素材的坐标位置及显示区域大小 */
		onLeftChange: function( newV, oldV ){
			if( this.curArea.areaNo==0 ) return;
			this.curArea.left = newV;
			this.mv_pre.style["left"] = (newV)+"px";
			this.FlushKey1++;
		},
		onTopChange: function( newV, oldV ){
			if( this.curArea.areaNo==0 ) return;
			this.curArea.top = newV;
			this.mv_pre.style["top"] = (newV)+"px";
			this.FlushKey1++;
		},
		onWidthChange: function( newV, oldV ){
			if( this.curArea.areaNo==0 ) return;
			this.curArea.width = newV;
			this.mv_pre.style["width"] = (newV)+"px";
			this.change_rs_ele.style["left"] = (newV-20)+"px";
			this.FlushKey1++;
		},
		onHeightChange: function( newV, oldV ){
			if( this.curArea.areaNo==0 ) return;
			this.curArea.height = newV;
			this.mv_pre.style["height"] = (newV)+"px";
			this.change_rs_ele.style["top"] = (newV-20)+"px";
			this.FlushKey1++;
		},
		/* 旋转 */
		onRotateChange: function( newV, oldV ){
			console.log( newV );
			if( this.curArea.areaNo==0 ) return;
			this.mv_pre.style["transform"] = "rotate("+newV+"deg)";
			this.FlushKey1++;
		},
		/* 区域改变大小控制相关事件 */
		onBlkDown: function(e){
			e.clientX2 = Math.ceil(e.clientX/this.rate);
			e.clientY2 = Math.ceil(e.clientY/this.rate);
			if( e.stopPropagation ) e.stopPropagation();

			// 记录触发时的数据
			this.rs_ele = e.target;
			this.rs_cx  = e.clientX2;
			this.rs_cy  = e.clientY2;
		},
		/* 区域拖动控制相关事件 */
		area_onmousedown: function(e){
			e.clientX2 = Math.ceil(e.clientX/this.rate);
			e.clientY2 = Math.ceil(e.clientY/this.rate);
			if( e.stopPropagation ) e.stopPropagation();

			if( this.LabInput.flag == 1 )
			{
				//console.error("阻止响应");
				return;
			}

			// 取消前一个被选中的元素的选中状态
			if( this.mv_pre )
			{
				this.mv_pre.style["border"] = "1px solid #00ffff";
				let blk = this.mv_pre.childNodes[1];
				if( blk ) blk.style["display"] = "none";
			}

			// 获取选中元素并且置为选中状态
			if( e.target.getAttribute("class")=="MediaAreaPan" )
			{
				this.mv_ele = e.target;
				this.mv_pre = e.target;
			}
			else
			{
				this.mv_ele = e.target.parentNode;
				this.mv_pre = e.target.parentNode;
			}
			if( this.mv_ele )
			{
				this.mv_ele.style["border"] = "1px solid #ff0000";
				let blk = this.mv_ele.childNodes[1];
				blk.style["display"] = "block";

				this.change_rs_ele = blk;
			}

			// 记录触发时的数据
			this.mv_ml = parseInt(this.mv_ele.style["left"].replace(/px/g, ""));
			this.mv_mt = parseInt(this.mv_ele.style["top"].replace(/px/g, ""));
			this.mv_cx = e.clientX2;
			this.mv_cy = e.clientY2;

			// 选中时, 取得对应的area对象
			let areano=this.mv_ele.getAttribute("areaNo");
			for(let i=0; i<this.templaItem.areas.length; i++ )
			{
				if( this.templaItem.areas[i].areaNo == areano )
				{
					this.curArea = this.templaItem.areas[i];
					this.FlushKey1++;
					this.FlushKey6++;
				}
			}

			this.showAreaList( );
		},
		area_onmousemove: function(e){
			e.clientX2 = Math.ceil(e.clientX/this.rate);
			e.clientY2 = Math.ceil(e.clientY/this.rate);
			if( e.stopPropagation ) e.stopPropagation();

			if( this.mv_ele )
			{
				let w2 = this.mv_ele.clientWidth;
				let h2 = this.mv_ele.clientHeight;

				let difX=e.clientX2 - this.mv_cx;    // 触发时与当前鼠标的X坐标差
				let difY=e.clientY2 - this.mv_cy;    // 触发是与当前鼠标的Y坐标差

				if( (this.mv_ml+difX) < 0   )
					 difX = -this.mv_ml;
				else if( (this.templaItem.width-2) < (this.mv_ml+difX+w2))
					 difX = this.templaItem.width-2 - w2 - this.mv_ml;

				if( (this.mv_mt+difY) < 0   )
					 difY = -this.mv_mt;
				else if( (this.templaItem.height-2)< (this.mv_mt+difY+h2))
					 difY = this.templaItem.height-2 - h2 - this.mv_mt;

				this.mv_ele.style["left"] = (this.mv_ml+difX)+"px";
				this.mv_ele.style["top"]  = (this.mv_mt+difY)+"px";

				this.curArea.left = this.mv_ml+difX;
				this.curArea.top  = this.mv_mt+difY;
				this.FlushKey1++;
			}
			if( this.rs_ele )
			{
				let dif1=e.clientX2 - this.rs_cx;
				let dif2=e.clientY2 - this.rs_cy;
				this.rs_cx = e.clientX2;
				this.rs_cy = e.clientY2;
				if( 0 < (this.curArea.width+dif1) )
				{
					if( (this.curArea.left+this.curArea.width+dif1) <= this.templaItem.width )
						 this.curArea.width = this.curArea.width + dif1;
					else this.curArea.width = this.templaItem.width - this.curArea.left;

					this.rs_ele.parentNode.style["width"] = (this.curArea.width)+"px";
					this.rs_ele.style["left"] = (this.curArea.width-20)+"px";
				}
				if( 0 < (this.curArea.height+dif2) )
				{
					if( (this.curArea.top+this.curArea.height+dif2) <= this.templaItem.height )
						 this.curArea.height= this.curArea.height + dif2;
					else this.curArea.height = this.templaItem.height - this.curArea.top;

					this.rs_ele.parentNode.style["height"] = (this.curArea.height)+"px";
					this.rs_ele.style["top"]  = (this.curArea.height-20)+"px";
				}

				this.FlushKey1++;
			}
		},
		area_onmouseup: function(e){
			if( e.stopPropagation ) e.stopPropagation();
			this.mv_ele = null;
			this.rs_ele = null;

			this._snapPhoto( false );
		},
	}
}

</script>

<style>

.MediaAreaPan{ position:absolute; background:#ffffff; border:1px solid #00ffff; cursor:move; }
.MediaAreaPan .AreaRsz{ position:absolute; background:#ff0000; width:20px; height:20px; }

</style>

<style scoped>

.OPRate{ cursor:pointer; }
.OPRate:hover{ opacity:0.5; }
.MediaItem{ float:left; width:40px; height:40px; margin-left:5px; margin-top:10px; border:1px solid #bbbbbb; cursor:pointer; }
.MediaItem:hover{ opacity:0.5; }

</style>



// WEBPACK FOOTER //
// TemplaEdit.vue?75b6ff43